function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { InfoOutlined } from "@mui/icons-material";
import { FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel, Checkbox as MuiCheckbox } from "@mui/material";
import cn from "clsx";
import { omit } from "lodash";
import { useCallback, useId, useMemo } from "react";
export var Checkbox = function(_param) {
    var label = _param.label, className = _param.className, _param_checked = _param.checked, checked = _param_checked === void 0 ? false : _param_checked, error = _param.error, errorMessage = _param.errorMessage, innerRef = _param.innerRef, hideError = _param.hideError, formField = _param.formField, fullWidth = _param.fullWidth, onChange = _param.onChange, _param_size = _param.size, size = _param_size === void 0 ? 'small' : _param_size, _param_value = _param.value, value = _param_value === void 0 ? '' : _param_value, props = _object_without_properties(_param, [
        "label",
        "className",
        "checked",
        "error",
        "errorMessage",
        "innerRef",
        "hideError",
        "formField",
        "fullWidth",
        "onChange",
        "size",
        "value"
    ]);
    var _props_options;
    var checkboxLegendId = useId();
    var errorId = useId();
    var onValueChange = useCallback(function(e) {
        if (onChange) {
            /*@ts-expect-error: issue in ts*/ onChange(value, e);
        }
    }, [
        onChange,
        value
    ]);
    var isChecked = useMemo(function() {
        var _props_options;
        if (!props.multiple) return;
        /*@ts-expect-error: issue in ts*/ return (_props_options = props.options) === null || _props_options === void 0 ? void 0 : _props_options.map(function(option) {
            return Array.isArray(value) ? value.map(function(v) {
                return v.value;
            }).includes(option.value) : false;
        });
    /*@ts-expect-error: issue in ts*/ }, [
        props.multiple,
        value,
        props.options
    ]);
    return /*#__PURE__*/ _jsxs(FormControl, {
        className: cn('flex', className),
        "data-component": "checkbox",
        "data-testid": props.name,
        error: error,
        fullWidth: fullWidth,
        children: [
            props.multiple ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    !!label && /*#__PURE__*/ _jsx(FormLabel, {
                        component: "legend",
                        "data-component": "checkboxLegend",
                        "data-testid": props.name,
                        id: checkboxLegendId,
                        children: label
                    }),
                    /*#__PURE__*/ _jsx(FormGroup, {
                        "aria-describedby": errorMessage ? errorId : undefined,
                        "aria-invalid": !!props.required,
                        "aria-labelledby": checkboxLegendId,
                        "aria-required": !!error,
                        "data-component": "checkboxGroup",
                        "data-testid": props.name,
                        //@ts-expect-error: issue in ts with complex types
                        row: props.row,
                        children: (_props_options = props.options) === null || _props_options === void 0 ? void 0 : _props_options.map(function(option, i) {
                            return /*#__PURE__*/ _jsx(FormControlLabel, {
                                control: /*#__PURE__*/ _jsx(MuiCheckbox, _object_spread_props(_object_spread({
                                    checked: isChecked[i],
                                    inputProps: {
                                        'aria-checked': isChecked[i],
                                        'data-component': 'checkboxInput',
                                        'data-optionindex': i,
                                        'data-testid': option.value
                                    },
                                    name: option.label,
                                    ref: innerRef,
                                    size: size,
                                    value: option.value
                                }, omit(props, 'name', 'row', 'value')), {
                                    onChange: onValueChange
                                })),
                                "data-component": "checkboxLabel",
                                "data-testid": option.value,
                                disableTypography: true,
                                label: option.label,
                                value: "end"
                            }, "".concat(option.label, "-").concat(option.value));
                        })
                    })
                ]
            }) : /*#__PURE__*/ _jsx(FormControlLabel, {
                control: /*#__PURE__*/ _jsx(MuiCheckbox, _object_spread_props(_object_spread({
                    checked: !!checked,
                    inputProps: {
                        'aria-checked': !!checked,
                        'aria-describedby': errorMessage ? errorId : undefined,
                        'aria-invalid': !!error,
                        'aria-required': !!props.required,
                        'data-component': 'checkboxInput',
                        'data-testid': props.name
                    },
                    size: size,
                    value: value
                }, props), {
                    onChange: onValueChange,
                    ref: innerRef
                })),
                "data-component": "checkboxLabel",
                "data-testid": props.name,
                disableTypography: true,
                label: label
            }),
            formField && /*#__PURE__*/ _jsx(FormHelperText, {
                "aria-atomic": "true",
                className: "mx-0",
                "data-component": "checkboxError",
                "data-testid": props.name,
                id: errorId,
                role: "alert",
                children: !hideError && errorMessage ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(InfoOutlined, {
                            className: "mr-1",
                            color: "error",
                            fontSize: "small"
                        }),
                        !!label && /*#__PURE__*/ _jsxs("span", {
                            className: "sr-only",
                            children: [
                                "Error for ",
                                label,
                                ":"
                            ]
                        }),
                        errorMessage
                    ]
                }) : ' '
            })
        ]
    });
};
Checkbox.displayName = 'Checkbox';

//# sourceMappingURL=Checkbox.js.map